import { useEffect, useRef, useCallback } from 'react';

const useScrollReveal = (options = {}) => {
  const elementRef = useRef(null);

  const setRef = useCallback((el) => {
    elementRef.current = el;
    if (!el) return;

    // If element is already in view when ref is set, reveal immediately
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.classList.add('revealed');
    }
  }, []);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    if (element.classList.contains('revealed')) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add('revealed');
          observer.disconnect();
        }
      },
      {
        threshold: options.threshold || 0.1,
        rootMargin: options.rootMargin || '0px 0px -50px 0px',
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [options.threshold, options.rootMargin]);

  return setRef;
};

export default useScrollReveal;
